module.exports = __webpack_public_path__ + "img/card-generic-gold.2e9487c4.svg";